import {
    getRateCardModifierSemantics,
    modifierAffectsRunningScope,
} from "routes/scenarios/rate-card-modifier-semantics.mjs"
import { getCurrencySymbol } from "../format-utils"
import { describeLegacyRateCardModifierScope } from "./rate-card-modifier-scope"

export function describeRateCardModifier({ modifier, index, modifiers, tradeOptions, currency }) {
    const step = index + 1
    const semantics = getRateCardModifierSemantics(modifier)
    const isNegative = Number(modifier.value) < 0
    const action = isNegative ? "subtracts" : "adds"
    const direction = isNegative ? "from" : "to"
    const rawValue = Math.abs(Number(modifier.value) || 0)
    const scope = describeLegacyRateCardModifierScope(modifier.scope, tradeOptions)

    if (modifier.type === "fixed") {
        const symbol = getCurrencySymbol(currency)
        return `Step ${step}: ${action} ${symbol}${formatNumber(rawValue)} ${direction} the running total${scope}.`
    }

    if (modifier.type === "percentage" && semantics.useBase) {
        return `Step ${step}: ${action} ${formatNumber(rawValue * 100)}% of the original base cost${scope}.`
    }

    if (modifier.type === "percentage") {
        const earlierSteps = findEarlierAffectingSteps(modifiers, index, modifier)
        const suffix = describeEarlierSteps(earlierSteps)
        return `Step ${step}: ${action} ${formatNumber(rawValue * 100)}% ${direction} the running total${scope}${suffix}.`
    }

    return `Step ${step}: no adjustment is applied.`
}

function findEarlierAffectingSteps(modifiers, index, targetModifier) {
    const steps = []
    for (let priorIndex = 0; priorIndex < index; priorIndex++) {
        if (modifierAffectsRunningScope(modifiers[priorIndex], targetModifier)) steps.push(priorIndex + 1)
    }
    return steps
}

function describeEarlierSteps(steps) {
    if (!steps.length) return ""
    if (steps.length === 1) return ` after Step ${steps[0]}`
    const last = steps[steps.length - 1]
    return ` after Steps ${steps.slice(0, -1).join(", ")} and ${last}`
}

function formatNumber(value) {
    return Number(value).toLocaleString("en-GB", { maximumFractionDigits: 2 })
}
